import Swiper, { Navigation, Pagination, Autoplay,EffectFade } from 'swiper';
const TenantDetail = {

    init() {
        if ($('.jsTenantDetail').length > 0) {
            this.initSlider();
        }
    },
    initSlider() {
        new Swiper($('.jsTenantDetail')[0], {
          slidesPerView: 1,
          loop: true,
          autoplay:true,
          spaceBetween: 30,
           
            modules: [Navigation, Pagination,Autoplay,EffectFade],
        });
    },  
}
export default TenantDetail;


// WEBPACK FOOTER //
// ./scripts/modules/components/_tenant-detail.js